import { LayoutDashboard, Settings, Users } from 'lucide-react';
import type { LucideIcon } from 'lucide-react';

export interface NavItem {
  label: string;
  description: string;
  to: string;
  icon: LucideIcon;
}

export const navItems: NavItem[] = [
  { label: 'Overview', description: 'Live statistics and recent activity', to: '/dashboard', icon: LayoutDashboard },
  { label: 'Students', description: 'Browse, search and edit records', to: '/students', icon: Users },
  { label: 'Settings', description: 'Account, security and appearance', to: '/settings', icon: Settings }
];
